// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerSpacer":"Header_headerSpacer__bInWU"};